<template>
  <div class="CPQ-business-blueprint">

    <div class="blueprint-content"
      :class="{ 'CPQ_blueprint_en': $i18n.locale === 'en_US', 'CPQ_blueprint_ja': $i18n.locale === 'ja_JP' }">
      <img :src="require('@/assets/images/ProductService/VyungCPQ/blueprint-background.png')" alt="" />
      <div class="d-flex flex-column" style="position: absolute;width: 128px; top: 10rem;left: 20px;">
        <div class="title">{{ $t('product.VyungCPQ.business_blueprint.application.title') }}</div>
        <div class="subtitle01">{{ $t('product.VyungCPQ.business_blueprint.application.subtitle01') }}</div>
      </div>
      <div style="position: absolute;width: 128px;top: 38rem;left: 20px;">
        <div class="title">{{ $t('product.VyungCPQ.business_blueprint.logic.title') }}</div>
        <div class="subtitle01">{{ $t('product.VyungCPQ.business_blueprint.logic.subtitle') }}</div>
      </div>
      <div
        :style="{ 'position': 'absolute', 'bottom': `${$i18n.locale === 'en_US' || $i18n.locale === 'ja_JP' ? '11rem' : '10rem'}`, 'width': '128px', 'left': '20px' }">
        <div class="title">{{ $t('product.VyungCPQ.business_blueprint.data_layer.title') }}</div>
        <div class="subtitle01">{{ $t('product.VyungCPQ.business_blueprint.data_layer.subtitle') }}</div>
      </div>

      <div class="d-flex" style="position: absolute;top: 17rem;left: 18.5rem; width: 85%;">
        <div class="subtitle02 flex-fill">{{ $t('product.VyungCPQ.business_blueprint.application.subtitle02') }}</div>
        <div class="subtitle02 flex-fill">{{ $t('product.VyungCPQ.business_blueprint.application.subtitle03') }}</div>
        <div class="subtitle02 flex-fill">{{ $t('product.VyungCPQ.business_blueprint.application.subtitle04') }}</div>
        <div class="subtitle02 flex-fill">{{ $t('product.VyungCPQ.business_blueprint.application.subtitle05') }}</div>
        <div class="subtitle02 flex-fill">{{ $t('product.VyungCPQ.business_blueprint.application.subtitle06') }}</div>
      </div>


      <div class="lh-lg" style="position: absolute;top: 27rem;left: calc(18rem);width: 250px;">
        <div class="subtitle02 mb--10">{{ $t('product.VyungCPQ.business_blueprint.logic.card01.subtitle') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card01.text01') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card01.text02') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card01.text03') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card01.text04') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card01.text05') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card01.text06') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card01.text07') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card01.text08') }}</div>
      </div>
      <div class="lh-lg" style="position: absolute;top: 27rem;left: calc(18rem + 250px);width: 238px;">
        <div class="subtitle02 mb--10">{{ $t('product.VyungCPQ.business_blueprint.logic.card02.subtitle') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card02.text01') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card02.text02') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card02.text03') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card02.text04') }}</div>
      </div>

      <div class="lh-lg" style="position: absolute;top: 27rem;left: calc(18rem + 488px);width: 238px;">
        <div class="subtitle02 mb--10">{{ $t('product.VyungCPQ.business_blueprint.logic.card03.subtitle') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card03.text01') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card03.text02') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card03.text03') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card03.text04') }}</div>
      </div>

      <div style="position: absolute;top: 27rem;left: calc(18rem + 726px);width: 238px;">
        <div class="subtitle02 mb--10">{{ $t('product.VyungCPQ.business_blueprint.logic.card04.subtitle') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card04.text01') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card04.text02') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card04.text03') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card04.text04') }}</div>
      </div>

      <div class="lh-lg" style="position: absolute;top: 27rem;left: calc(18rem + 964px);width: 238px;">
        <div class="subtitle02 mb--10">{{ $t('product.VyungCPQ.business_blueprint.logic.card07.subtitle') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card07.text01') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card07.text02') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card07.text03') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card07.text04') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card07.text05') }}</div>
        <div>{{ $t('product.VyungCPQ.business_blueprint.logic.card07.text06') }}</div>
      </div>
      <div style="position: absolute;top: 48rem;left: 42rem;">
        <div class="subtitle02 mb--10">{{ $t('product.VyungCPQ.business_blueprint.logic.card05.subtitle') }}</div>
        <div class="d-flex flex-wrap" style="width: 360px;">
          <div class="col-6">{{ $t('product.VyungCPQ.business_blueprint.logic.card05.text01') }}</div>
          <div class="col-6">{{ $t('product.VyungCPQ.business_blueprint.logic.card05.text02') }}</div>
          <div class="col-6">{{ $t('product.VyungCPQ.business_blueprint.logic.card05.text03') }}</div>
        </div>
      </div>
      <div style="position: absolute;top: 48rem;right: 25.3rem;">
        <div class="subtitle02 mb--10">{{ $t('product.VyungCPQ.business_blueprint.logic.card06.subtitle') }}</div>
        <div class="d-flex flex-wrap" style="width: 360px;">
          <div class="col-6">{{ $t('product.VyungCPQ.business_blueprint.logic.card06.text01') }}</div>
          <div class="col-6">{{ $t('product.VyungCPQ.business_blueprint.logic.card06.text02') }}</div>
        </div>
      </div>
      <div
        :style="{ 'position': 'absolute', 'top': `${$i18n.locale === 'en_US' ? '64.5rem' : '66rem'}`, 'left': `${$i18n.locale === 'en_US' ? '19rem' : $i18n.locale === 'ja_JP' ? '18.5rem' : '19.5rem'}` }">
        <div class="subtitle02">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.subtitle01') }}</div>
        <div class="d-flex flex-wrap" style="width: 370px;">
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text01') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text02') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text03') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text04') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text05') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text06') }}</div>
        </div>
      </div>
      <div
        :style="{ 'position': 'absolute', 'top': `${$i18n.locale === 'en_US' ? '64.5rem' : '66rem'}`, 'left': `${$i18n.locale === 'en_US' ? 'calc(19rem + 400px)' : $i18n.locale === 'ja_JP' ? 'calc(18.5rem + 400px)' : 'calc(19.5rem + 400px)'}` }">
        <div class="subtitle02">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.subtitle02') }}</div>
        <div class="d-flex flex-wrap" style="width: 370px;">
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text01') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text02') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text03') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text04') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text05') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text06') }}</div>
        </div>
      </div>
      <div
        :style="{ 'position': 'absolute', 'top': `${$i18n.locale === 'en_US' ? '64.5rem' : '66rem'}`, 'left': `${$i18n.locale === 'en_US' ? 'calc(19rem + 800px)' : $i18n.locale === 'ja_JP' ? 'calc(18.5rem + 800px)' : 'calc(19.5rem + 800px)'}` }">
        <div class="subtitle02">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.subtitle03') }}</div>
        <div class="d-flex flex-wrap" style="width: 370px;">
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text01') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text02') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text03') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text04') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text05') }}</div>
          <div class="col-4 p-2">{{ $t('product.VyungCPQ.business_blueprint.data_layer.card.text06') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CPQBusinessBlueprint',
}
</script>